import { render, staticRenderFns } from "./InvoiceListWithoutBcard.vue?vue&type=template&id=6878d01a&"
import script from "./InvoiceListWithoutBcard.vue?vue&type=script&lang=js&"
export * from "./InvoiceListWithoutBcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports